import { type PayoutFragment } from '@/affiliate-dashboard/graphql';
import { createColumnHelper } from '@tanstack/react-table';
import { format } from 'date-fns';
import { type IntlShape } from 'react-intl';

const columnHelper = createColumnHelper<PayoutFragment | null>();

export const defaultColumns = (
  intl: IntlShape,
  { t }: { t: (key: string) => string },
) => [
  columnHelper.accessor('amount', {
    id: 'amount	',
    header: () => t('table.Amount'),
    cell: (info) => (
      <span className="font-bold text-default-gray-950 dark:text-white">
        {intl.formatNumber(info.getValue() ?? 0, {
          style: 'currency',
          currency: 'USD',
          maximumFractionDigits: 2,
        })}
      </span>
    ),
  }),
  columnHelper.accessor('createdAt', {
    id: 'createdAt	',
    header: () => t('table.Date'),
    cell: (info) => (
      <div className="flex flex-col">
        <span>{format(info.getValue() ?? '', 'dd.MM.yyyy')}</span>
        <span>{info.row.original?.id}</span>
      </div>
    ),
  }),
  columnHelper.accessor('status', {
    id: 'status	',
    header: () => t('table.Status'),
    cell: (info) => (
      <div className="flex w-full justify-end">{info.getValue()}</div>
    ),
  }),
  // columnHelper.accessor('method', {
  //   id: 'method	',
  //   header: () => t('table.Method'),
  //   cell: (info) =>
  //     info.getValue() === WithdrawalPaymentMethod.DirectCrypto ? (
  //       <div className="flex items-center justify-end gap-2">
  //         <CryptoCurrency />
  //         {/*eslint-disable-next-line i18next/no-literal-string -- . */}
  //         <span>Crypto</span>
  //       </div>
  //     ) : (
  //       <div className="flex items-center justify-end gap-2">
  //         <RiseNoLabel />
  //         {/*eslint-disable-next-line i18next/no-literal-string -- . */}
  //         <span>Rise</span>
  //       </div>
  //     ),
  // }),
];
